import { useEffect, useMemo, useState } from 'react';
import useCompanies from '../../../../queries/useCompanies';

const empty_arr = [];

const useAddressesTreeDataNew = ({ enabled = true, companyId }) => {
  const [treeData, setTreeData] = useState([]);

  const { data: companies = empty_arr, isFetching } = useCompanies({
    staleTime: Infinity,
    enabled,
  });

  const company = useMemo(() => {
    if (!enabled) return null;

    return companies?.find((item) => item.id === companyId);
  }, [companies, companyId, enabled]);

  useEffect(() => {
    let newData = [];

    if (!!company && !!company?.id) {
      newData = [
        {
          key: `${company.id}`,
          id: company.id,
          parentId: null,
          title: company.name,
          // searchPlaceholder: 'Поиск по компании',
          // isLeaf: false,
        },
      ];
    }

    setTreeData(newData);
  }, [company]);

  return { treeData, setTreeData, loading: isFetching };
};

export default useAddressesTreeDataNew;
